import Axios from "axios";
import { Paper, Stack, Title } from "@mantine/core";
import { AgCharts, AgChartProps } from "ag-charts-react";
import { useEffect, useState } from "react";

interface IStat {
  logDate: Date;
  nrOfInternalUsers: number;
  nrOfExternalUsers: number;
}

const UserChart = () => {
  const [stats, setStats] = useState<IStat[]>([]);

  useEffect(() => {
    async function fetchData() {
      const res = await Axios.get("/api/stats");
      const statsFetch: IStat[] = res.data;

      setStats(statsFetch);
    }

    fetchData();
  }, []);

  const options: AgChartProps["options"] = {
    data: stats.map((stat) => ({
      ...stat,
      logDate: new Date(stat.logDate),
    })),
    title: {
      text: "Users logged in last 30 days",
    },
    axes: [
      {
        type: "time",
        position: "bottom",
      },
      {
        type: "number",
        position: "left",
        title: {
          text: "Number of users",
        },
      },
    ],
    legend: {
      position: "right",
    },
    series: [
      {
        type: "area",
        xKey: "logDate",
        yKey: "nrOfInternalUsers",
        yName: "Multiconsult employees",
        fill: "#ff9800",
        stroke: "#ff9800",
        stacked: true,
      },
      {
        type: "area",
        xKey: "logDate",
        yKey: "nrOfExternalUsers",
        yName: "External users",
        stacked: true,
      },
    ],
  };

  return (
    <div className="m-3">
      <Paper withBorder p="sm" radius="sm" bg="#fdfdff">
        <Stack gap="xs">
          <Title order={4} fw={400}>
            User Statstics
          </Title>
          <AgCharts options={options} />
        </Stack>
      </Paper>
    </div>
  );
};

export default UserChart;
